import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'

import Axios from '../axios'
import { handleAPIError } from '../utility/actionHelper'

// THUNKS

export const getCommunityAccessControl = createAsyncThunk(
  'accessControl/getCommunityAccessControl',
  async (communityId, { rejectWithValue }) => {
    try {
      const { data } = await requestCommunityAccessControl(communityId)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const getCommunityAccessControlCoach = createAsyncThunk(
  'accessControl/getCommunityAccessControlCoach',
  async ({ communityId, accessControlId }, { rejectWithValue }) => {
    try {
      const { data } = await requestCommunityAccessControlCoach(communityId, accessControlId)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const createCommunityAccessControl = createAsyncThunk(
  'accessControl/createCommunityAccessControl',
  async ({ communityId, accessControlData }, { rejectWithValue }) => {
    try {
      const { data } = await requestCreateCommunityAccessControl(communityId, accessControlData)
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const updateCommunityAccessControl = createAsyncThunk(
  'accessControl/updateCommunityAccessControl',
  async ({ communityId, accessControlId, accessControlData }, { rejectWithValue }) => {
    try {
      const { data } = await requestUpdateCommunityAccessControl(communityId, accessControlId, accessControlData)
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

// API CALLS

const requestCommunityAccessControl = (communityId) => {
  const requestUrl = `/api/v1/communities/${communityId}/access_control`

  return Axios.get(requestUrl)
}

const requestCommunityAccessControlCoach = (communityId, accessControlId) => {
  const requestUrl = `/api/v1/coach/communities/${communityId}/access_controls/${accessControlId}`

  return Axios.get(requestUrl)
}

const requestCreateCommunityAccessControl = (communityId, accessControlData) => {
  const requestUrl = `/api/v1/coach/communities/${communityId}/access_controls`

  const data = new FormData()
  const serializedAccessControlData = serialize(accessControlData)
  Object.keys(serializedAccessControlData)
    .forEach((key) => data.append(`access_control[${key}]`, serializedAccessControlData[key]))

  return Axios.post(requestUrl, data)
}

const requestUpdateCommunityAccessControl = (communityId, accessControlId, accessControlData) => {
  const requestUrl = `/api/v1/coach/communities/${communityId}/access_controls/${accessControlId}`

  const data = new FormData()
  const serializedAccessControlData = serialize(accessControlData)
  Object.keys(serializedAccessControlData)
    .forEach((key) => data.append(`access_control[${key}]`, serializedAccessControlData[key]))

  return Axios.put(requestUrl, data)
}
